/* Book a wheelchair listing */
'use strict';

export default class BookWheelchairListing {
    constructor(element) {
        this.hasAccessories = false;
        this.root = element;
        this.form = document.querySelector('.book-wheelchair');
        this.wheelchairPricePerWeek = parseFloat(this.root.getAttribute('data-price-wc-input'));
        this.durationSelector = this.root.querySelector('select[data-duration-select]');
        this.selectedDuration = this.durationSelector.options[this.durationSelector.selectedIndex].value; //Default value
        this.wheelchairCost = this.wheelchairPricePerWeek * this.selectedDuration;
        this.startDateInput = new Date(this.root.getAttribute('data-start-date'));
        this.durationOutputs = this.root.querySelectorAll('[data-duration-output]');
        this.durationWarningMsg = this.root.querySelector('[data-duration-message]');
        this.wheelchairPriceOutputs = this.root.querySelectorAll('[data-wc-price-output]');
        this.accessorySelectorBlock = this.root.querySelector('[data-accessory-select]');
        if (this.accessorySelectorBlock) {
            this.hasAccessories = true;
        }
        if (this.hasAccessories === true) {
            this.accessorySelector = this.accessorySelectorBlock.querySelectorAll('input[type=checkbox]');
            this.accessoryListOutput = this.root.querySelector('[data-accessories-list]');

            for (let i = 0; i < this.accessorySelector.length; i++) {
                if(this.accessorySelector[i].checked) {
                    this.handleAccessorySelection(this.accessorySelector[i]);
                }
            }
        }

        this.bindEvents();
        this.handleDurationChange(this.durationSelector);
    }

    changeDurationText(duration) {
        //Re-set outputs - these can be added by the accessories selection
        this.durationOutputs = this.root.querySelectorAll('[data-duration-output]');
        //Change all duration outputs
        for (let i = 0; i < this.durationOutputs.length; i++) {
            this.durationOutputs[i].textContent = duration;
        }
    }

    changeCost(duration) {
        //Calc new individual item costs
        this.wheelchairCost = this.wheelchairPricePerWeek * duration;

        for (let i = 0; i < this.wheelchairPriceOutputs.length; i++) {
            this.wheelchairPriceOutputs[i].textContent = this.wheelchairCost.toFixed(2);
        }

        if (this.hasAccessories === true) {
            let accessoryList = this.accessoryListOutput.querySelectorAll('[data-acc-price-input]');

            for (let i = 0; i < accessoryList.length; i++) {
                let accessoryPrice = (parseFloat(accessoryList[i].textContent) * duration).toFixed(2);
                let accessoryCostOutput = accessoryList[i].parentNode.querySelector('[data-acc-price-output');
                accessoryCostOutput.textContent = accessoryPrice;
            }
        }
    }

    handleDurationChange(select) {
        this.selectedDuration = parseFloat(select.options[select.selectedIndex].getAttribute('data-duration-option'));
        
        this.changeDurationText(this.selectedDuration);

        this.changeCost(this.selectedDuration);
    }

    handleAccessorySelection(checkedItem) {
        let isChecked = checkedItem.checked;
        let accessoryName = checkedItem.nextSibling.textContent;
        let accessoryDataAttr = checkedItem.getAttribute('data-acc');
        let accessoryPrice = parseFloat(checkedItem.getAttribute('data-price-acc-input'));
        let accessoryList = this.accessoryListOutput.innerHTML;
        let accessoryCost = accessoryPrice * this.selectedDuration;

        if (isChecked) {
            accessoryList += `<span data-acc-${accessoryDataAttr}>${accessoryName}: £<span data-acc-price-input>${accessoryPrice.toFixed(2)}</span> x <span data-duration-output>${this.selectedDuration}</span> = £<span data-acc-price-output>${accessoryCost.toFixed(2)}</span><br/></span>`;
            this.accessoryListOutput.innerHTML = accessoryList;
        } else {
            this.accessoryListOutput.querySelector(`[data-acc-${accessoryDataAttr}]`).remove();
        }
    }

    bindEvents() {
        //User selects new duration for equipment booking
        this.durationSelector.addEventListener('change', this.handleDurationChange.bind(this, this.durationSelector));
        
        //User selects their accessories
        if (this.hasAccessories === true) {
            for (let i = 0; i < this.accessorySelector.length; i++) {
                this.accessorySelector[i].addEventListener('change', this.handleAccessorySelection.bind(this, this.accessorySelector[i]));
            }
        }
    }
}
